module.exports = __webpack_public_path__ + "turn_slight_right.svg?1e934867aff25b829a83c03631af2b92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/turn_slight_right.svg
// module id = 229
// module chunks = 0